import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { EventItem } from "@model";
import { PublicEventsService } from "@services";

const resolveEvents = (serviceMethod: 'findNewEventsList' | 'findUpcomingEventsList'): ResolveFn<Observable<EventItem[]>> =>  (_: ActivatedRouteSnapshot, __: RouterStateSnapshot, publicEventsService: PublicEventsService = inject(PublicEventsService)) =>
    publicEventsService[serviceMethod]();

export const NewEventsResolver = resolveEvents('findNewEventsList');
export const UpcomingEventsResolver = resolveEvents('findUpcomingEventsList');
